import { BaseParams, NodeData } from './base';
import { type ContextItemData, type DashboardItemData, type FolderItemData } from './types';

export interface CreateDashboardContextParams extends BaseParams {
  dashboardUid: string;
  dashboardTitle: string;
  folderUid?: string;
  folderTitle?: string;
}

export interface CreateFolderContextParams extends BaseParams {
  folderUid: string;
  folderTitle: string;
}

export class DashboardNodeData extends NodeData {
  public dashboardUid: string;
  public dashboardTitle: string;
  public folderUid?: string;
  public folderTitle?: string;

  constructor(params: CreateDashboardContextParams) {
    super({ ...params, id: params.dashboardUid, type: 'dashboard' });
    this.dashboardUid = params.dashboardUid;
    this.dashboardTitle = params.dashboardTitle;
    this.folderUid = params.folderUid;
    this.folderTitle = params.folderTitle;
    this.text = params.dashboardTitle;
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: this.type,
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.dashboardTitle,
        dashboardUid: this.dashboardUid,
        dashboardTitle: this.dashboardTitle,
        folderUid: this.folderUid,
        folderTitle: this.folderTitle,
        text: this.text,
      } satisfies DashboardItemData,
    };
  }
}

export class FolderNodeData extends NodeData {
  public folderUid: string;
  public folderTitle: string;
  public text = '';

  constructor(params: CreateFolderContextParams) {
    super({ ...params, id: params.folderUid, type: 'dashboard_folder' });
    this.folderUid = params.folderUid;
    this.folderTitle = params.folderTitle;
    this.text = params.folderTitle;
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: this.type,
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.folderTitle,
        folderUid: this.folderUid,
        folderTitle: this.folderTitle,
        text: this.text,
      } satisfies FolderItemData,
    };
  }
}
